
import React, { useState } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';
import { ChevronDown, Tag } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface BrowseTagFilterProps {
  tags: string[];
  activeTag: string | null;
  onTagChange: (tag: string | null) => void;
}

const BrowseTagFilter: React.FC<BrowseTagFilterProps> = ({
  tags,
  activeTag,
  onTagChange
}) => {
  const { resolvedTheme } = useTheme();
  const [open, setOpen] = useState(false);
  
  const textColor = resolvedTheme === 'dark' ? 'text-white' : 'text-black';
  const mutedTextColor = resolvedTheme === 'dark' ? 'text-white/70' : 'text-black/70';
  const borderColor = resolvedTheme === 'dark' ? 'border-white/20' : 'border-black/20';
  const bgColor = resolvedTheme === 'dark' ? 'bg-netflix-black' : 'bg-background';
  
  return (
    <div className="w-full">
      <div className="flex items-center gap-2 mb-2">
        <Tag size={16} className={textColor} />
        <h3 className={cn("text-sm font-medium", textColor)}>Filter by tag</h3>
      </div>
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger className={cn(
          "w-full flex items-center justify-between px-3 py-2 border rounded-md text-sm",
          borderColor,
          textColor
        )}>
          <span>{activeTag || 'All Tags'}</span>
          <ChevronDown size={16} />
        </DropdownMenuTrigger>
        <DropdownMenuContent className={cn(
          "w-[200px] max-h-[300px] overflow-y-auto z-50",
          bgColor,
          borderColor
        )}>
          <DropdownMenuItem 
            className={cn(
              "cursor-pointer",
              !activeTag ? "font-medium" : ""
            )}
            onClick={() => {
              onTagChange(null);
              setOpen(false);
            }}
          >
            All Tags
          </DropdownMenuItem>
          
          {tags.map(tag => (
            <DropdownMenuItem 
              key={tag}
              className={cn(
                "cursor-pointer capitalize",
                activeTag === tag ? "font-medium" : ""
              )}
              onClick={() => {
                onTagChange(tag);
                setOpen(false);
              }}
            >
              {tag}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default BrowseTagFilter;
